import { useState, useRef, useEffect } from "react";
import { BroadcastChannel } from "broadcast-channel";

interface BroadcastMessageProps {
    type: string;
    payload?: any;
}

type BroadcastStateProps = BroadcastMessageProps | null;

export function useBroadcast(
    channelName: string = "BROADCAST",
    initialState: BroadcastStateProps = { type: "UNKNOWN" }
): [BroadcastStateProps, (value: BroadcastMessageProps) => void] {
    const [state, setState] = useState<BroadcastStateProps>(initialState);
    const channel = useRef<BroadcastChannel>(new BroadcastChannel(channelName));

    useEffect(() => {
        /* istanbul ignore next */
        if (channel.current) {
            channel.current.onmessage = (event: MessageEvent) =>
                setState(event);
        }
        const currentChannel = channel.current;

        return () => {
            currentChannel && currentChannel.close();
        };
    }, [channelName]);

    const postMessage = (value: BroadcastMessageProps) => {
        channel.current && channel.current.postMessage(value);
    };

    return [state, postMessage];
}
